import React, { useEffect, useState } from 'react'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '../firebase'  // Adjust import to your Firebase config

const TourEssentials = () => {
  const [participants, setParticipants] = useState([])

  useEffect(() => {
    const fetchAllParticipants = async () => {
      try {
        // Get all reservation documents
        const snapshot = await getDocs(collection(db, 'reservations'))
        const reservations = snapshot.docs.map((doc) => doc.data())

        // Flatten the participants array from each reservation
        const allParticipants = reservations.flatMap((res) => res.participants || [])
        setParticipants(allParticipants)
      } catch (error) {
        console.error('Error fetching reservations:', error)
      }
    }

    fetchAllParticipants()
  }, [])

  return (
    <div className="max-w-3xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">All Participants</h1>
      {participants.length === 0 ? (
        <p>No participants found.</p>
      ) : (
        <ul className="space-y-2">
          {participants.map((p, idx) => (
            <li key={idx} className="flex items-center">
              {/* Name */}
              <span className="mr-2 font-semibold">
                {p.firstName} {p.lastName}:
              </span>
              {/* Clickable email link (mailto:) */}
              {p.email ? (
                <a
                  href={`mailto:${p.email}`}
                  className="text-blue-600 underline"
                >
                  {p.email}
                </a>
              ) : (
                <span className="text-gray-500">No Email</span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default TourEssentials
